import I18n from "@vocollege/app/dist/modules/Services/I18n";
import Login from "./auth/Login";
import Dashboard from "./dashboard";
import Diplomas from "./diplomas";
import DiplomaForm from "./diplomas/DiplomaForm";
import Certificates from "./certificates";
import CertificateForm from "./certificates/CertificateForm";
import TutorCertificates from "./tutorCertificates";
import TutorCertificateForm from "./tutorCertificates/TutorCertificateForm";
import TutorAwardCertificates from "./tutorAwardCertificates";
import TutorAwardCertificateForm from "./tutorAwardCertificates/TutorAwardCertificateForm";
import CareAssistantDiplomas from "./careAssistantDiplomas";
import CareAssistantDiplomaForm from "./careAssistantDiplomas/CareAssistantDiplomaForm";
import AmbassadorCertificates from "./ambassadorCertificates";
import AmbassadorCertificateForm from "./ambassadorCertificates/AmbassadorCertificateForm";
import LanguageRepresentativeDiplomas from "./languageRepresentativeDiplomas";
import LanguageRepresentativeDiplomaForm from "./languageRepresentativeDiplomas/LanguageRepresentativeDiplomaForm";
import LanguageRepresentativeEducatorDiplomas from "./languageRepresentativeEducatorDiplomas";
import LanguageRepresentativeEducatorDiplomaForm from "./languageRepresentativeEducatorDiplomas/LanguageRepresentativeEducatorDiplomaForm";
import CourseMoments from "./courseMoments";
import CourseMomentForm from "./courseMoments/CourseMomentForm";
import CollegeCertificates from "./collegeCertificates";
import CollegeCertificateForm from "./collegeCertificates/CollegeCertificateForm";

import Statistics from "./statistics";
import StatisticsDiplomas from "containers/Statistics/Diplomas";
import StatisticsCertificates from "containers/Statistics/Certificates";
import StatisticsTutorCertificates from "containers/Statistics/TutorCertificates";
import StatisticsCareAssistantDiplomas from "containers/Statistics/CareAssistantDiplomas";
import StatisticsAmbassadorCertificates from "containers/Statistics/AmbassadorCertificates";
import StatisticsLanguageRepresentativeDiplomas from "containers/Statistics/LanguageRepresentativeDiplomas";
import StatisticsLanguageRepresentativeEducatorDiplomas from "containers/Statistics/LanguageRepresentativeEducatorDiplomas";
import StatisticsCourseMoments from "containers/Statistics/CourseMoments";

interface Routes {
  [key: string]: any;
}

const routes = (): Routes => {
  return {
    auth: {
      abilities: false,
      path: "/auth",
      hideHeader: true,
    },
    login: {
      abilities: false,
      path: "/login",
      component: Login,
      hideHeader: true,
    },
    root: {
      abilities: true,
      path: "/",
      component: Dashboard,
      label: I18n.get.misc.dashboard,
    },

    diplomas: {
      path: "/diplom",
      component: Diplomas,
      label: I18n.get.diploma.labels.diplomas,
      abilities: [
        {
          action: "list_own_diplomas",
          subject: "Cert",
        },
      ],
    },
    "diplomas.id": {
      path: "/diplom/:id",
      component: DiplomaForm,
      abilities: [
        {
          action: "create_own_diplomas",
          subject: "Cert",
        },
      ],
    },

    certificates: {
      path: "/intyg",
      component: Certificates,
      label: I18n.get.certificate.labels.certificates,
      abilities: [
        {
          action: "list_own_certificates",
          subject: "Cert",
        },
      ],
    },
    "certificates.id": {
      path: "/intyg/:id",
      component: CertificateForm,
      abilities: [
        {
          action: "create_own_certificates",
          subject: "Cert",
        },
      ],
    },

    tutorCertificates: {
      path: "/handledarintyg",
      component: TutorCertificates,
      label: I18n.get.tutorCertificate.labels.tutorCertificates,
      abilities: [
        {
          action: "list_own_tutor_certificates",
          subject: "Cert",
        },
      ],
    },
    "tutorCertificates.id": {
      path: "/handledarintyg/:id",
      component: TutorCertificateForm,
      abilities: [
        {
          action: "create_own_tutor_certificates",
          subject: "Cert",
        },
      ],
    },
    tutorAwardCertificates: {
      path: "/certifikat-arets-handledare",
      component: TutorAwardCertificates,
      label: I18n.get.tutorAwardCertificate.labels.tutorAwardCertificates,
      abilities: [
        {
          action: "list_own_tutor_award_certificates",
          subject: "Cert",
        },
      ],
    },
    "tutorAwardCertificates.id": {
      path: "/certifikat-arets-handledare/:id",
      component: TutorAwardCertificateForm,
      abilities: [
        {
          action: "create_own_tutor_award_certificates",
          subject: "Cert",
        },
      ],
    },

    ambassadorCertificates: {
      path: "/intyg-ambassador",
      component: AmbassadorCertificates,
      label: I18n.get.ambassadorCertificate.labels.ambassadorCertificates,
      abilities: [
        {
          action: "list_own_ambassador_certificates",
          subject: "Cert",
        },
      ],
    },
    "ambassadorCertificates.id": {
      path: "/intyg-ambassador/:id",
      component: AmbassadorCertificateForm,
      abilities: [
        {
          action: "create_own_ambassador_certificates",
          subject: "Cert",
        },
      ],
    },

    careAssistantDiplomas: {
      path: "/diplom-vardbitrade",
      component: CareAssistantDiplomas,
      label: I18n.get.careAssistantDiploma.labels.careAssistantDiplomas,
      abilities: [
        {
          action: "list_own_care_assistant_diplomas",
          subject: "Cert",
        },
      ],
    },
    "careAssistantDiplomas.id": {
      path: "/diplom-vardbitrade/:id",
      component: CareAssistantDiplomaForm,
      abilities: [
        {
          action: "create_own_care_assistant_diplomas",
          subject: "Cert",
        },
      ],
    },

    languageRepresentativeDiplomas: {
      path: "/diplom-sprakombud",
      component: LanguageRepresentativeDiplomas,
      label:
        I18n.get.languageRepresentativeDiploma.labels
          .languageRepresentativeDiplomas,
      abilities: [
        {
          action: "list_own_language_representative_diplomas",
          subject: "Cert",
        },
      ],
    },
    "languageRepresentativeDiplomas.id": {
      path: "/diplom-sprakombud/:id",
      component: LanguageRepresentativeDiplomaForm,
      abilities: [
        {
          action: "create_own_language_representative_diplomas",
          subject: "Cert",
        },
      ],
    },

    languageRepresentativeEducatorDiplomas: {
      path: "/diplom-sprakombudsutbildare",
      component: LanguageRepresentativeEducatorDiplomas,
      label:
        I18n.get.languageRepresentativeEducatorDiploma.labels
          .languageRepresentativeEducatorDiplomas,
      abilities: [
        {
          action: "list_own_language_representative_educator_diplomas",
          subject: "Cert",
        },
      ],
    },
    "languageRepresentativeEducatorDiplomas.id": {
      path: "/diplom-sprakombudsutbildare/:id",
      component: LanguageRepresentativeEducatorDiplomaForm,
      abilities: [
        {
          action: "create_own_language_representative_educator_diplomas",
          subject: "Cert",
        },
      ],
    },

    courseMoments: {
      path: "/utbildningar",
      component: CourseMoments,
      label: I18n.get.vocertCourseMoment.labels.courseMoments,
      abilities: [
        {
          action: "list_own_course_moments",
          subject: "Cert",
        },
      ],
    },
    "courseMoments.id": {
      path: "/utbildningar/:id",
      component: CourseMomentForm,
      abilities: [
        {
          action: "create_own_course_moments",
          subject: "Cert",
        },
      ],
    },

    collegeCertificates: {
      path: "/college-certifikat",
      component: CollegeCertificates,
      label: I18n.get.collegeCertificate.labels.collegeCertificates,
      abilities: [
        {
          action: "list_own_college_certificates",
          subject: "Cert",
        },
      ],
    },
    "collegeCertificates.id": {
      path: "/college-certifikat/:id",
      component: CollegeCertificateForm,
      abilities: [
        {
          action: "create_own_college_certificates",
          subject: "Cert",
        },
      ],
    },

    statistics: {
      path: "/statistik",
      component: Statistics,
      label: I18n.get.statistics.labels.statistics,
      abilities: [
        {
          action: "access_statistics",
          subject: "Cert",
        },
      ],
    },

    "statistics.diplomas": {
      path: "/statistik/diplom",
      component: StatisticsDiplomas,
      label: I18n.get.diploma.labels.diplomas,
      abilities: [
        {
          action: "access_statistics",
          subject: "Cert",
        },
        {
          action: "list_own_diplomas",
          subject: "Cert",
        },
      ],
    },

    "statistics.certificates": {
      path: "/statistik/intyg",
      component: StatisticsCertificates,
      label: I18n.get.certificate.labels.certificates,
      abilities: [
        {
          action: "access_statistics",
          subject: "Cert",
        },
        {
          action: "list_own_certificates",
          subject: "Cert",
        },
      ],
    },

    "statistics.tutorCertificates": {
      path: "/statistik/handledarintyg",
      component: StatisticsTutorCertificates,
      label: I18n.get.tutorCertificate.labels.tutorCertificates,
      abilities: [
        {
          action: "access_statistics",
          subject: "Cert",
        },
        {
          action: "list_own_tutor_certificates",
          subject: "Cert",
        },
      ],
    },

    "statistics.careAssistantDiplomas": {
      path: "/statistik/diplom-vardbitrade",
      component: StatisticsCareAssistantDiplomas,
      label: I18n.get.careAssistantDiploma.labels.careAssistantDiplomas,
      abilities: [
        {
          action: "access_statistics",
          subject: "Cert",
        },
        {
          action: "list_own_care_assistant_diplomas",
          subject: "Cert",
        },
      ],
    },

    "statistics.ambassadorCertificates": {
      path: "/statistik/intyg-ambassador",
      component: StatisticsAmbassadorCertificates,
      label: I18n.get.ambassadorCertificate.labels.ambassadorCertificates,
      abilities: [
        {
          action: "access_statistics",
          subject: "Cert",
        },
        {
          action: "list_own_ambassador_certificates",
          subject: "Cert",
        },
      ],
    },

    "statistics.languageRepresentativeDiplomas": {
      path: "/statistik/diplom-sprakombud",
      component: StatisticsLanguageRepresentativeDiplomas,
      label:
        I18n.get.languageRepresentativeDiploma.labels
          .languageRepresentativeDiplomas,
      abilities: [
        {
          action: "access_statistics",
          subject: "Cert",
        },
        {
          action: "list_own_language_representative_diplomas",
          subject: "Cert",
        },
      ],
    },

    "statistics.languageRepresentativeEducatorDiplomas": {
      path: "/statistik/diplom-sprakombudsutbildare",
      component: StatisticsLanguageRepresentativeEducatorDiplomas,
      label:
        I18n.get.languageRepresentativeEducatorDiploma.labels
          .languageRepresentativeEducatorDiplomas,
      abilities: [
        {
          action: "access_statistics",
          subject: "Cert",
        },
        {
          action: "list_own_language_representative_educator_diplomas",
          subject: "Cert",
        },
      ],
    },

    "statistics.courseMoments": {
      path: "/statistik/utbildningar",
      component: StatisticsCourseMoments,
      label: I18n.get.vocertCourseMoment.labels.courseMoments,
      abilities: [
        {
          action: "access_statistics",
          subject: "Cert",
        },
        {
          action: "list_own_course_moments",
          subject: "Cert",
        },
      ],
    },
  };
};

export default routes();
